<template>
  <v-form v-model="valid" :lazy-validation="false" ref="form">
    <v-container>
      <v-row>
        <v-col cols="3" align-self="center">供應商類別</v-col>
        <v-col v-if="isEdit" cols="9" class="text-left">
          {{ category && category.categoryName }}
        </v-col>
        <v-col v-else cols="9" class="text-left">
          <v-select :items="merchantCategories" label="類別" v-model="item.categoryId" item-text="categoryName"
            item-value="categoryId" :rules="requiredRule('供應商類別')" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">供應商</v-col>
        <v-col v-if="isEdit" cols="9" class="text-left">
          {{ item.merchantName }}
        </v-col>
        <v-col v-else cols="9" class="text-left">
          <v-select :disabled="!item.categoryId" :items="merchantSelect" label="供應商" v-model="item.merchantId"
            item-text="text" item-value="value" :rules="merchantRule" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">產品類別</v-col>
        <v-col cols="9">
          <v-select :disabled="isEdit" :items="productTypeList" label="產品類別" v-model="item.productType" item-text="text"
            item-value="value" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">序號類型</v-col>
        <v-col cols="9">
          <v-select label="序號類型" :items="voucherDisplayTypes" item-text="text" item-value="value"
            v-model="item.displayType"></v-select>
        </v-col>
      </v-row>
      <v-row v-if="!isEdit">
        <v-col cols="3">點數類別</v-col>
        <v-col cols="9" class="text-left">
          <v-autocomplete v-model="item.categories" :items="categories" item-text="catName" item-value="catId"
            :rules="typeRule" clearable multiple chips deletable-chips>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row v-if="!isEdit">
        <v-col cols="3">標籤類別</v-col>
        <v-col cols="9" class="text-left">
          <v-autocomplete v-model="item.tags" :items="tags" item-text="tagName" item-value="tagId" clearable multiple
            chips deletable-chips>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">品項名稱</v-col>
        <v-col cols="9">
          <v-text-field label="品項名稱" v-model="item.productName" :rules="productNameRule"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">兌換點數</v-col>
        <v-col cols="9">
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-left">點數</th>
                <th class="text-left">現金</th>
                <th class="text-center">
                  <v-btn icon color="indigo" v-show="showAddPaymentSolution" @click="addSolution">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(solution, index) in item.paymentSolutions" :key="solution.id">
                <td>
                  <v-text-field label="點數" v-model.number="solution.point" :rules="getRequiredNumberRule('點數')" />
                </td>
                <td>
                  <v-text-field label="現金" v-model.number="solution.cash" :rules="getRequiredNumberRule('現金')" />
                </td>
                <td>
                  <v-btn icon color="deep-orange" v-show="showRemovePaymentSolution" @click="removeSolution(index)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
      <v-row v-if="isThereCashSolution">
        <v-col cols="3" align-self="center">使用其他點數支付</v-col>
        <v-col cols="9" class="text-left">
          <v-checkbox v-for="pay in otherPayList" v-model="item.otherPays" :value="pay.pointId" :label="pay.pointName"
            :key="pay.pointId" />
        </v-col>
      </v-row>
      <v-row v-if="isPhysicalGoods(displayType)">
        <v-col cols="3" align-self="center">運費</v-col>
        <v-col cols="9">
          <v-text-field label="運費" v-model.number="item.shippingFee"
            :rules="getRequiredNumberRule('運費')"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">成本</v-col>
        <v-col cols="9">
          <v-text-field label="成本" v-model.number="item.cost" :rules="costRule"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">原價點數</v-col>
        <v-col cols="9">
          <v-text-field label="原價點數" v-model.number="item.originalPrice" :rules="originalPriceRule"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">最低手續費</v-col>
        <v-col cols="9">
          <v-text-field label="最低手續費" v-model.number="item.serviceFee" :rules="serviceFeeRule"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">手續費比率(%)</v-col>
        <v-col cols="9">
          <v-text-field label="手續費比率(%)" v-model.number="item.serviceFeePercentage"
            :rules="serviceFeePercentageRule"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">回饋百分比(%)</v-col>
        <v-col cols="9">
          <v-text-field label="回饋百分比(%)" v-model.number="item.pointBackPercentage"
            :rules="servicePointBackPercentageRule"></v-text-field>
        </v-col>
      </v-row>
      <template v-if="item.productType === 4">
        <v-row>
          <v-col cols="3" align-self="center">分潤金額(%)</v-col>
          <v-col cols="9">
            <v-radio-group v-model="item.profitDistributionType" row>
              <v-radio label="折價前" v-bind:value="0"></v-radio>
              <v-radio label="折價後" v-bind:value="1"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col offset="3" cols="9">
            <v-text-field label="分潤金額(%)" v-model.number="item.profitDistributionPercentage"
              :rules="getNumberRule('分潤金額(%)')"></v-text-field>
          </v-col>
        </v-row>
      </template>
      <v-row>
        <v-col cols="3" align-self="center">品項連結</v-col>
        <v-col cols="9">
          <v-text-field label="品項連結" v-model="item.link"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">狀態</v-col>
        <v-col cols="9">
          <v-select :items="statusList" label="狀態" v-model="item.isEnable" item-text="text" item-value="value" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">商品總數</v-col>
        <v-col cols="9">
          <v-text-field label="商品總數" v-model.number="item.quantity" :rules="quantityRule"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">帳號兌換次數限制</v-col>
        <v-col cols="9">
          <v-text-field label="帳號兌換次數限制" v-model.number="item.purchaseQuantityLimit"
            :rules="purchaseQuantityLimitRule"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">單次兌換數量</v-col>
        <v-col cols="9">
          <v-select label="單次兌換數量" :items="exchangeQuantityList" v-model="item.tranMulti" item-text="text"
            item-value="value" :disabled="disableTranMulti" />
        </v-col>
      </v-row>
      <v-row v-if="item.tranMulti">
        <v-col cols="3" align-self="center">最低兌換數量</v-col>
        <v-col cols="9">
          <v-text-field label="最低兌換數量" v-model.number="item.minimumPurchaseQuantity"
            :rules="serviceMinimumPurchaseQuantityRule"></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="item.productType === 2">
        <v-col cols="3" align-self="center">特定額度商品</v-col>
        <v-col cols="9">
          <v-checkbox v-model="item.isSpecificDenominationProduct" label="單筆交易若有多張票券，僅會請求單一張" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">上傳圖片
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="black" small dark v-bind="attrs" v-on="on">
                mdi-information
              </v-icon>
            </template>
            <span>尺寸比例為 1200*592</span>
          </v-tooltip>
        </v-col>
        <v-col cols="9" class="images">
          <v-file-input ref="fileUploader" :rules="checkImages" @change="addImage($event)"
            accept="image/png, image/jpeg, image/bmp" placeholder="上傳圖片" prepend-icon="mdi-camera"
            label=""></v-file-input>
          <v-item-group mandatory v-model="listImageUrl">
            <v-container>
              <v-row>
                <v-col v-for="(image, index) in item.images" :key="image.imageId" cols="6">
                  <v-item v-slot="{ active, toggle }" :value="image.imageUrl">
                    <v-card :color="active ? 'primary' : ''" class="d-flex align-center" @click="toggle">
                      <v-img :src="image.imageUrl" contain>
                        <v-app-bar flat color="rgba(0, 0, 0, 0)">
                          <v-spacer></v-spacer>
                          <v-btn color="#ccc" elevation="1" small fab @click.stop.prevent="removeImage(index)">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-app-bar>
                      </v-img>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>
        </v-col>
      </v-row>
      <template v-if="item.productType === 4">
        <v-row>
          <v-col cols="3" align-self="center">折扣方式</v-col>
          <v-col cols="9">
            <v-select label="折扣方式" v-model="item.discountType" :items="discountTypes" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" align-self="center">{{ discountLabel }}</v-col>
          <v-col cols="9">
            <v-text-field :label="discountPlaceholder" v-model.number="item.discount"
              :rules="getRequiredNumberRule(discountLabel)"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" align-self="center">最低消費限制</v-col>
          <v-col cols="9">
            <v-text-field label="最低消費限制" v-model.number="item.minimumCharge"
              :rules="getNumberRule('最低消費限制')"></v-text-field>
          </v-col>
        </v-row>
      </template>
      <v-row>
        <v-col cols="3" align-self="center">{{ tranMemoLabel }}</v-col>
        <v-col cols="9">
          <v-textarea outlined name="input-7-4" :label="tranMemoLabel" v-model="item.tranMemo"></v-textarea>
        </v-col>
      </v-row>
      <v-row v-if="item.productType !== 4">
        <v-col cols="3" align-self="center">產品規格</v-col>
        <v-col cols="9">
          <v-textarea outlined name="input-7-4" label="產品規格" v-model="item.specifications"></v-textarea>
        </v-col>
      </v-row>
      <template v-else>
        <v-row>
          <v-col cols="3" align-self="center">使用方法</v-col>
          <v-col cols="9">
            <v-textarea outlined name="input-7-4" label="使用方法" v-model="item.howToUse"></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" align-self="center">注意事項</v-col>
          <v-col cols="9">
            <v-textarea outlined name="input-7-4" label="注意事項" v-model="item.notice"></v-textarea>
          </v-col>
        </v-row>
      </template>
      <v-row>
        <v-col cols="3" align-self="center">附加參數</v-col>
        <v-col cols="9">
          <v-textarea outlined name="input-7-4" label="附加參數" v-model="item.additionalParameters"
            :rules="isJsonObjectRule"></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">上架日期</v-col>
        <v-col>
          <date-time-picker v-model="item.startTime" label="上架日期" :rules="startDateRule" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">下架日期</v-col>
        <v-col>
          <date-time-picker v-model="item.endTime" label="下架日期" :rules="endDateRule" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" align-self="center">開賣日期</v-col>
        <v-col>
          <date-time-picker v-model="item.salesStartTime" label="開賣日期" :rules="salesStartTimeRule" />
        </v-col>
      </v-row>
      <v-row>
        <v-col></v-col>
        <v-col class="text-right">
          <v-btn class="ma-2" @click.stop="back">取消</v-btn>
          <v-btn class="ma-2" tile @click.stop="submit">確定</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import api from '@/api';
import DateTimePicker from '@/components/DateTimePicker.vue';
import itemMixin from '@/minix/itemMixin';
import ruleMixin from '@/minix/ruleMixin';
import moment from 'moment';
import imageConvert from '@/utils/image';
import { mapState } from 'vuex';
import Swal from 'sweetalert2';

const MaxPaymentSolutionsCount = 2;
const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
export default {
  mixins: [itemMixin, ruleMixin],
  components: {
    DateTimePicker,
  },
  data() {
    return {
      valid: true,
      item: {
        merchantName: '',
        merchantId: '',
        categories: [],
        tags: [],
        otherPays: [],
        productName: '',
        productType: 1,
        displayType: null,
        cost: 0,
        shippingFee: 0,
        originalPrice: 0,
        serviceFee: null,
        serviceFeePercentage: null,
        pointBackPercentage: null,
        profitDistributionType: 0,
        profitDistributionPercentage: 0,
        minimumPurchaseQuantity: 1,
        link: '',
        isEnable: 1,
        salesStartTime: null,
        startTime: null,
        endTime: null,
        tranMulti: 0,
        tranMemo: '',
        specifications: '',
        discountType: 3,
        discount: 0,
        minimumCharge: '',
        howToUse: null,
        notice: null,
        images: [],
        paymentSolutions: [{ point: '', cash: '' }],
        purchaseQuantityLimit: null,
        isSpecificDenominationProduct: false,
      },
      statusList: [
        {
          text: '停用',
          value: false,
        },
        {
          text: '啟用',
          value: true,
        },
      ],
      productTypeList: [
        { text: '產品', value: 1 },
        { text: '點數', value: 2 },
        { text: '折價券', value: 4 },
      ],
      discountTypes: [
        { text: '折抵', value: 3 },
        { text: '打折', value: 4 },
      ],
      exchangeQuantityList: [
        {
          text: '單個',
          value: false,
        },
        {
          text: '多個',
          value: true,
        },
      ],
      checkImages: [(v) => !!this.item.images.length || '至少要有一張圖片'],
      merchantRule: this.requiredRule('供應商'),
      productNameRule: this.requiredRule('產品名稱'),
      startDateRule: this.requiredRule('開始時間'),
      endDateRule: this.requiredRule('結束時間'),
      costRule: this.getRequiredNumberRule('成本'),
      originalPriceRule: this.getRequiredNumberRule('原價'),
      serviceFeeRule: this.getNumberRule('手續費'),
      serviceFeePercentageRule: this.getNumberRule('手續費百分比'),
      servicePointBackPercentageRule: this.getNumberRule('回饋百分比'),
      serviceMinimumPurchaseQuantityRule: [
        ...this.getRequiredNumberMinRule('最低兌換數量', 1),
        (v) => {
          if (this.item.purchaseQuantityLimit > 1) {
            const max = this.item.purchaseQuantityLimit;
            return v <= max || `最低兌換數量必須小於或等於${max}`;
          }
          return true;
        },
      ],
      salesStartTimeRule: [
        (v) => !v || moment(v) >= moment(this.item.startTime) || '要大於上架日期',
        (v) => !v || moment(v) <= moment(this.item.endTime) || '要小於下架日期',
      ],
      quantityRule: this.getRequiredNumberRule('商品數量'),
      isJsonObjectRule: [
        (v) => {
          let isJson = false;
          if (v) {
            try {
              isJson = typeof JSON.parse(v) === 'object';
            } catch {
              isJson = false;
            }
          }
          return !v || isJson || '必須是JSON格式內容';
        },
      ],
      typeRule: [(v) => !!v.length || '請選擇點數類別'],
      purchaseQuantityLimitRule: this.getNumberMaxRule('帳號兌換次數限制', 32767),
    };
  },
  watch: {
    'item.productType': function productTypeWatcher(newValue) {
      if (this.isEdit === true) {
        return;
      }
      switch (newValue) {
        case 2:
          this.item.displayType = 16;
          break;
        case 4:
          this.item.displayType = 128;
          this.item.specifications = null;
          this.item.isSpecificDenominationProduct = false;
          break;
        default:
          this.item.displayType = null;
          this.item.isSpecificDenominationProduct = false;
          break;
      }
    },
    'item.displayType': function displayTypeWatcher(newValue, oldValue) {
      if (!this.isPhysicalGoods(oldValue)) return;
      if (!this.isPhysicalGoods(this.displayType)) {
        this.item.shippingFee = 0;
      }
    },
    isThereCashSolution(newValue) {
      this.item.otherPays = newValue ? this.item.otherPays : [];
    },
    'item.purchaseQuantityLimit': function purchaseQuantityLimitWatcher(newValue) {
      if (!newValue) return;
      if (newValue === 1) {
        this.item.tranMulti = false;
      }
      this.item.tranMulti = !(newValue === 1);
      this.item.minimumPurchaseQuantity = 1;
    },
  },
  computed: {
    displayType() {
      return this.item.displayType === null
        ? this.merchant?.displayType
        : this.item.displayType;
    },
    merchant() {
      return this.$store.state.merchant.merchantList.find(
        ({ merchantId }) => merchantId === this.item.merchantId,
      );
    },
    category() {
      return this.merchantCategories.find(
        ({ categoryId }) => categoryId === this.item.categoryId,
      );
    },
    merchantSelect() {
      return this.merchantList
        .filter(({ categoryId }) => categoryId === this.item.categoryId)
        .map(({ merchantId, merchantName }) => ({
          text: merchantName,
          value: merchantId,
        }));
    },
    listImageUrl: {
      get: function getter() {
        return this.item.images.find((img) => img.isListImage)?.imageUrl;
      },
      set: function setter(val) {
        this.item.images.forEach((img) => {
          img.isListImage = img.imageUrl === val; // eslint-disable-line no-param-reassign
        });
      },
    },
    isEdit() {
      return this.$route.name === 'swapOutProductEdit';
    },
    itemId() {
      return this.$route.params.id;
    },
    fileRules() {
      return [
        (v) => !!v || !!this.productPic || '檔案 為必填',
        (v) => !v || v.size < 4000000 || '照片大小不可大於 4 MB!',
      ];
    },
    categories() {
      return this.typeList.filter(this.isSameProductType);
    },
    tags() {
      return this.tagList.filter(this.isSameProductType);
    },
    tranMemoLabel() {
      return this.item.productType === 4 ? '優惠券內容' : '兌換說明';
    },
    discountLabel() {
      return this.item.discountType === 3 ? '折抵' : '折數';
    },
    discountPlaceholder() {
      return this.item.discountType === 3
        ? '折抵點數'
        : '請輸入打折成數，ex: 打8折，請輸入20';
    },
    showAddPaymentSolution() {
      return this.item.paymentSolutions.length < MaxPaymentSolutionsCount;
    },
    showRemovePaymentSolution() {
      return this.item.paymentSolutions.length > 1;
    },
    isThereCashSolution() {
      return this.item.paymentSolutions.findIndex((s) => s.cash > 0) > -1;
    },
    ...mapState({
      voucherDisplayTypes: (state) => [
        { text: '繼承廠商', value: null },
        ...state.merchant.voucherDisplayTypes,
      ],
    }),
    disableTranMulti() {
      return !!this.item.purchaseQuantityLimit && this.item.purchaseQuantityLimit === 1;
    },
  },
  created() {
    if (this.isEdit) {
      this.getItem();
    }
  },
  methods: {
    isPhysicalGoods(displayType) {
      // tslint:disable-next-line:no-bitwise
      return (displayType & 32) === 32;
    },
    getNumberRule(text) {
      return [(v) => !v || /^\d*(\.\d+)?$/.test(v) || `${text} 必須是數字`];
    },
    getRequiredNumberRule(text) {
      return [...this.getNumberRule(text), ...this.requiredRule(text)];
    },
    getRequiredNumberMinRule(text, min) {
      return [
        ...this.getRequiredNumberRule(text),
        (v) => v >= min || `${text}必須大於或等於${min}`,
      ];
    },
    getNumberMaxRule(text, max) {
      return [
        ...this.getNumberRule(text),
        (v) => v <= max || `${text}必須小於或等於${max}`,
      ];
    },
    async addImage(event) {
      if (event) {
        this.$refs.fileUploader.clearableCallback();
        // 過濾重複上傳
        const base64 = await imageConvert(event);
        if (this.item.images.findIndex((img) => img.imageUrl === base64) > -1) {
          return;
        }
        this.item.images.push({ imageUrl: base64, isListImage: false });
      }
    },
    isSameProductType(item) {
      // tslint:disable-next-line: no-bitwise
      return (item.productType & this.item.productType) > 0;
    },
    addSolution() {
      if (this.item.paymentSolutions.length < MaxPaymentSolutionsCount) {
        this.item.paymentSolutions.push({});
      }
    },
    removeSolution(index) {
      this.item.paymentSolutions.splice(index, 1);
    },
    removeImage(index) {
      this.item.images.splice(index, 1);
    },
    async getItem() {
      const { data } = await api.product.get(this.itemId);
      const product = data || {};
      const { categoryId } = this.merchantList.find(
        ({ merchantId }) => merchantId === product.merchantId,
      );
      const salesStartTime = product.salesStartTime
        ? moment(product.salesStartTime).format(dateTimeFormat)
        : null;
      this.item = {
        ...product,
        categoryId,
        startTime: moment(product.startTime).format(dateTimeFormat),
        endTime: moment(product.endTime).format(dateTimeFormat),
        salesStartTime,
      };
    },
    async submit() {
      if (this.item.displayType === 128 && this.item.tranMulti === true) {
        await await Swal.fire({
          icon: 'warning',
          title: '正掃類型無法一次兌換多個',
        });
        return;
      }
      if (!this.$refs.form.validate()) {
        return;
      }
      const submitData = {
        ...this.item,
        isEnable: Boolean(this.item.isEnable),
        tranMulti: Boolean(this.item.tranMulti),
      };

      const action = this.isEdit ? 'edit' : 'add';
      let productType = '';
      if (this.item.productType === 4) productType = 'DiscountCoupon';
      else if (this.item.productType === 2) productType = 'Point';
      const apiName = `${action}${productType}`;
      const args = [submitData];
      if (this.isEdit) {
        args.splice(0, 0, this.itemId);
      }
      const { status } = await api.product[apiName](...args);

      if (status === 1) {
        this.back();
      }
    },
    back() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}

.v-card {
  padding: 5px;
}

.images .v-item--active::after {
  content: '列表圖';
  position: absolute;
  top: 0;
  left: 0;
  background: darken(#1976d2, 20%) !important;
  color: white;
  padding: 3px;
  border-radius: 0 0 5px 0;
}
</style>
